import { GridViewOutlinedIcon, ListItemButton, ListItemIcon, Text } from '@shared/components';
import { useConfig } from '@user-management/configuration';
import { useCallback } from 'react';

import { TooltipMenu } from '../../components';

interface BackToPortalMenuItemProps {
  minified: boolean;
}

function BackToPortalMenuItem(props: Readonly<BackToPortalMenuItemProps>) {
  const { minified: isMinified } = props;
  const { loginUrl } = useConfig();

  const text = 'Back to Portal';

  const backToPortal = useCallback(() => {
    window.location.href = loginUrl;
  }, [loginUrl]);

  return (
    <TooltipMenu title={isMinified ? text : ''}>
      <ListItemButton component='li' onClick={backToPortal}>
        <ListItemIcon>
          <GridViewOutlinedIcon />
        </ListItemIcon>
        <Text>{text}</Text>
      </ListItemButton>
    </TooltipMenu>
  );
}

export default BackToPortalMenuItem;
